<template>
  <div>
    <div class="date-picker"
         @click.stop>
      <div>

        <ul class="date-picker-year d-flex flex-wrap justify-content-between list-unstyled">
          <li class="date-picker-year_item position-relative"
              :class="{ 'date-picker-year_active': currentYear === year }"
              v-for="year in uniqueYears">
            <div @click.stop="filterItemsByYear(year)">
              {{ year }}
            </div>
          </li>
        </ul>

        <div class="container">
          <ul class="row">
            <li class="col-4 date-picker-month_content"
                v-for="month in months" 
                :key="month">
              <div class="date-picker-month_item"
                   :class="{'date-picker-month_selected': isMonthSelected(month),
                            'p-0-important': isMonthDisabled(month)
                   }">
  
                <div class="date-picker-month_disabled text-center"
                      v-if="isMonthDisabled(month)">
                  {{ month }}
                </div>
  
                <div v-for="item in filterItemsByMonth(month)">
                  <label class="m-0" 
                          :class="{ 'd-none': !isItemInCurrentYear(item) }">
  
                    <input type="checkbox" 
                           :name="name" 
                           v-model="item.selected" 
                           :value="item.value" 
                           :title="item.value">
  
                    <span class="d-flex justify-content-center" 
                          :title="item.label">
                      {{ item.label.split(' ')[0] }}
                    </span>
  
                  </label>
                </div>

              </div>
            </li>
          </ul>
        </div>

        <button class="btn holiday-search__btn search-button border-radius-none max-w-100 w-100 mt-2"
                type="button" 
                @click="applySelection"
                aria-label="Apply selection"
                title="Apply selection">
          Done
        </button>

      </div>            
    </div>
  </div>
</template>

<script>
import {Brand} from '../../brand.js';
import {Months} from '../../months.js';

export default {
  props: ['items', 'label', 'name', 'brandName'],

  data() {
    return {
      Brand,
      currentYear: '',
      months: Months
    };
  },

  computed: {
    uniqueYears() {
      const yearsSet = new Set();
      
      this.items.forEach(item => {
        const year = item.label.split(" ")[1];
        yearsSet.add(year);
      });

      return Array.from(yearsSet).sort();
    },

    minYear() {
      const years = this.items.map(item => parseInt(item.label.split(" ")[1], 10));
      const minYear = Math.min(...years);
      return minYear;
    }
  },

  mounted() {
    this.setInitialYear();
  },

  watch: {
    items: {
      handler() {
        this.setInitialYear();
      },
      immediate: true
    }
  },

  methods: {
    setInitialYear() {
      this.currentYear = this.minYear.toString();
    },

    getMonthItem(month) {
      return this.items.find(item => {
        const [itemMonth, itemYear] = item.label.split(" ");
        return itemMonth === month && itemYear === this.currentYear;
      }) || { };
    },

    isMonthSelected(month) {
      const monthItem = this.getMonthItem(month);
      return monthItem && monthItem.selected;
    },

    filterItemsByYear(year) {
      this.currentYear = year;
    },

    isMonthDisabled(month) {
      return !this.items.some(x => {
        const [itemMonth, itemYear] = x.label.split(' ');
        return itemMonth === month && itemYear === this.currentYear;
      });
    },

    isItemInCurrentYear(item) {
      return item.label.split(' ')[1] === this.currentYear;
    },

    filterItemsByMonth(month) {
      return this.items.filter(x => x.label.split(' ')[0] === month);
    },

    applySelection() {
      this.$parent[`toggle${this.label}`]();
    }
  }
};
</script>
